<template>
    <span class="material-symbols-outlined mt-0.5 select-none" :class="cssClass">
        {{ props.name }}
    </span>
</template>

<script lang="ts" setup>
    import type { Props } from './props'
    import { ICON_SIZE } from './icon'

    const props = defineProps<Props>()

    const cssClass = computed(() => {
        return {
            'text-4xl leading-[2.5rem]': props.size === ICON_SIZE.medium,
            'text-[2.75rem]': props.size === ICON_SIZE.big,
            'lg:text-[2.75rem]': props.size === ICON_SIZE.bigDesktop,
            'material-symbols-outlined--filled': props.filled,
        }
    })
</script>

<style>
    .material-symbols-outlined {
        font-variation-settings:
            'FILL' 0,
            'wght' 200,
            'GRAD' 0,
            'opsz' 48;

        &--filled {
            font-variation-settings:
                'FILL' 1,
                'wght' 200,
                'GRAD' 0,
                'opsz' 48;
        }
    }
</style>
